var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleInner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.66037,
    y: 1.01825,
    width: 26.9635,
    height: 26.9635,
    rx: 13.4818,
    fill: "url(#paint0_linear_10924_278)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.66037,
    y: 1.01825,
    width: 26.9635,
    height: 26.9635,
    rx: 13.4818,
    stroke: "url(#paint1_linear_10924_278)",
    strokeWidth: 1.75073
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10924_278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3946 17.0124H15.953V11.9876H15.3946V10.1563H20.52C21.4505 10.1563 22.1763 10.3462 22.6974 10.7258C23.2185 11.1055 23.479 11.6489 23.479 12.3561C23.479 12.7953 23.3748 13.1675 23.1664 13.4727C22.9579 13.7705 22.7123 13.9975 22.4294 14.1539C22.154 14.3027 21.886 14.4032 21.6254 14.4553V14.567C22.154 14.6191 22.6304 14.7866 23.0547 15.0695C23.479 15.3524 23.6912 15.8586 23.6912 16.5881C23.6912 17.3697 23.3971 17.9429 22.809 18.3077C22.221 18.665 21.4579 18.8437 20.52 18.8437H15.3946V17.0124ZM19.6825 13.8189C19.8984 13.8189 20.0584 13.763 20.1626 13.6514C20.2743 13.5323 20.3301 13.3499 20.3301 13.1042V12.7022C20.3301 12.4566 20.2743 12.2779 20.1626 12.1663C20.0584 12.0472 19.8984 11.9876 19.6825 11.9876H19.0795V13.8189H19.6825ZM19.7607 17.0124C19.9765 17.0124 20.1366 16.9566 20.2408 16.8449C20.3525 16.7258 20.4083 16.5434 20.4083 16.2978V15.8065C20.4083 15.5608 20.3525 15.3821 20.2408 15.2705C20.1366 15.1514 19.9765 15.0918 19.7607 15.0918H19.0795V17.0124H19.7607Z",
    fill: "#7D5A01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0794 16.0521H14.5211V18.2854C14.1936 18.4715 13.7134 18.639 13.0807 18.7879C12.4554 18.9293 11.7779 19 11.0484 19C9.65635 19 8.56578 18.6353 7.7767 17.9057C6.98762 17.1687 6.59308 16.0335 6.59308 14.5C6.59308 12.9293 6.9839 11.7866 7.76554 11.072C8.55462 10.3573 9.67869 10 11.1377 10C11.8449 10 12.5075 10.0745 13.1253 10.2233C13.7432 10.3722 14.2085 10.5397 14.5211 10.7258V13.3946H11.7296V12.8697C11.7296 12.5571 11.6626 12.3338 11.5286 12.1998C11.402 12.0583 11.1973 11.9876 10.9144 11.9876C10.6315 11.9876 10.4231 12.0583 10.2891 12.1998C10.1626 12.3338 10.0993 12.5571 10.0993 12.8697V16.1303C10.0993 16.4429 10.1626 16.67 10.2891 16.8114C10.4231 16.9454 10.6315 17.0124 10.9144 17.0124C11.1973 17.0124 11.402 16.9454 11.5286 16.8114C11.6626 16.67 11.7296 16.4429 11.7296 16.1303V16.0521H11.1266V14.3884H15.0794V16.0521Z",
    fill: "#7D5A01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10924_278",
    x: 6.59308,
    y: 10,
    width: 17.0981,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10924_278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10924_278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10924_278",
    x1: 15.1421,
    y1: 1.89362,
    x2: 15.1421,
    y2: 27.1064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B81A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10924_278",
    x1: 15.1421,
    y1: 1.89362,
    x2: 15.1421,
    y2: 27.1064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#795700"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleInner);
export default ForwardRef;